<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form :form="form" layout="inline" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!--        筛选的条件-->
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="订单号" style="margin-left: 42px">
                <a-input v-model="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单状态" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes2" :title="type.label" :key="type.value">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单子状态" style="margin-left: 13px">
                <a-select v-model="queryParam.orderSubstatus" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes3" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业名称" style="margin-left: 26px">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange"
                  v-model="queryParam.enterpriseId"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data5" :title="item.enterpriseName" :key="item.enterpriseId">{{
                    item.enterpriseName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="客户姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.clientName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户联系方式">
                <a-input v-model.trim="queryParam.clientPhone" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-row :gutter="16" style="margin-left: 0px">
                <a-form-item label="客户地址" style="margin-left: 26px">
                  <a-col :span="5">
                    <a-select
                      v-decorator="['provinceId']"
                      style="margin-right: 10px"
                      @change="haveProvince1"
                      allowClear="true"
                    >
                      <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{
                        type.provinceName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="5">
                    <a-select
                      v-decorator="['cityId']"
                      style="margin-right: 10px"
                      @change="haveProvince2"
                      allowClear="true"
                    >
                      <a-select-option :title="type.cityName" v-for="type in data2" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="5">
                    <a-select
                      v-decorator="['districtId']"
                      style="margin-right: 10px"
                      @change="haveProvince3"
                      allowClear="true"
                    >
                      <a-select-option :title="type.areaName" v-for="type in data3" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="9">
                    <a-input v-decorator="['detailedAddress']" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="安装类别" style="margin-left: 26px">
                <a-select v-model="queryParam.installType" @change="handleOrder" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes1" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单类型" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in data4" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="核销方式" style="margin-left: 26px">
                <a-select v-model="queryParam.writeoffMode" :allowClear="true">
                  <a-select-option value="0" title="自动核销">自动核销</a-select-option>
                  <a-select-option value="1" title="人工核销">人工核销</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="核销状态" style="margin-left: 26px">
                <a-select v-model="queryParam.writeoffStatus" :allowClear="true">
                  <a-select-option value="1" title="已核销">已核销</a-select-option>
                  <a-select-option value="0" title="未核销">未核销</a-select-option>
                  <a-select-option value="未接" title="未接">未接</a-select-option>
                  <a-select-option value="待跟进" title="待跟进">待跟进</a-select-option>
                  <a-select-option value="旧件未寄回" title="旧件未寄回">旧件未寄回</a-select-option>
                  <a-select-option value="不符合结单条件" title="不符合结单条件">不符合结单条件</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="8">
              <a-row>
                <a-form-item>
                  <a-col :span="6">
                    <a-select v-model="queryParam.timeType1" :allowClear="true">
                      <a-select-option v-for="type in options" :title="type.label" :key="type.value">
                        {{ type.label }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="18">
                    <a-range-picker
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                      }"
                      v-model="queryParam1.tiem1"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      @change="onChangerangepicker1"
                    />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
            <a-col :span="8">
              <a-row :gutter="16">
                <a-form-item>
                  <a-col :span="6">
                    <a-select v-model="queryParam.timeType2" :allowClear="true">
                      <a-select-option v-for="type in options" :title="type.label" :key="type.value">
                        {{ type.label }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="18">
                    <a-range-picker
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                      }"
                      v-model="queryParam1.tiem2"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      @change="onChangerangepicker2"
                    />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
            <a-col :span="8">
              <a-rows>
                <a-form-item>
                  <a-col :span="6">
                    <a-select v-model="queryParam.timeType3" :allowClear="true">
                      <a-select-option v-for="type in options" :title="type.label" :key="type.value">
                        {{ type.label }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="18">
                    <a-range-picker
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                      }"
                      v-model="queryParam1.tiem3"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      @change="onChangerangepicker3"
                    />
                  </a-col>
                </a-form-item>
              </a-rows>
            </a-col>
          </a-row>
          <div v-if="isShow == 1">
            <a-row :gutter="16">
              <a-col :span="6" v-if="selectAll">
                <a-form-item label="核销负责人" style="margin-left: 13px">
                  <a-input v-model.trim="queryParam.writeoffUserCharge" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="核销人" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.writeoffUser" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="订单负责人" style="margin-left: 13px">
                  <a-select v-model="queryParam.orderPrincipal" :allowClear="true">
                    <a-select-option v-for="type in data6" :title="type.userName" :key="type.userId">{{
                      type.userName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="当前协助人" style="margin-left: 13px">
                  <a-select
                    showSearch
                    v-model="queryParam.assistPerson"
                    :allowClear="true"
                    optionFilterProp="children"
                    :filterOption="filterOption"
                    @change="handleChange"
                  >
                    <a-select-option v-for="type in data6" :title="type.userName" :key="type.userId">{{
                      type.userName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-item label="师傅姓名" style="margin-left: 26px">
                  <a-input v-model.trim="queryParam.workName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="师傅联系方式">
                  <a-input v-model.trim="queryParam.workPhone" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="购买渠道" style="margin-left: 26px">
                  <a-input v-model.trim="queryParam.source" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="备注" style="margin-left: 59px">
                  <a-input v-model.trim="queryParam.remark" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="6">
                <a-row :gutter="16">
                  <a-form-item label="介入时间" style="margin-left: 34px">
                    <a-col :span="6">
                      <a-input placeholder="最小值" v-model.trim="queryParam.intervenTimeBegin" />
                    </a-col>
                    <a-col :span="1" style="display: flex; justify-content: center"> - </a-col>
                    <a-col :span="6">
                      <a-input placeholder="最大值" v-model.trim="queryParam.intervenTimeEnd" />
                    </a-col>
                    <a-col :span="10" :offset="1">
                      <a-radio-group
                        :options="optionsradio"
                        @change="onChangeRadioGroup"
                        v-model="queryParam.intervenTimeType"
                      />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :span="6">
                <a-form-item label="核销耗时" style="margin-left: 26px">
                  <a-col :span="6">
                    <a-input placeholder="最小值" v-model.trim="queryParam.writeoffTimeBegin" />
                  </a-col>
                  <a-col :span="1" style="display: flex; justify-content: center"> - </a-col>
                  <a-col :span="6">
                    <a-input placeholder="最大值" v-model.trim="queryParam.writeoffTimeEnd" />
                  </a-col>
                  <a-col :span="10" :offset="1">
                    <a-radio-group
                      :options="optionsradio"
                      @change="onChangeRadioGroup"
                      v-model="queryParam.writeoffTimeType"
                    />
                  </a-col>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="建单人" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.createName" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <!--        查询和清空按钮-->
          <!--<span class="table-page-search-submitButtons">-->
          <a-row>
            <a-col :span="15" style="display: flex; justify-content: space-between">
              <a-checkbox v-model="queryParam1.num1" @change="onChangeMyOrder">我的订单</a-checkbox>
              <a-checkbox v-model="queryParam1.num2" @change="onChangeRushOrder">加急订单</a-checkbox>
              <a-checkbox v-model="queryParam1.num3" @change="onChangeImportanceOrder">重要订单</a-checkbox>
              <a-checkbox v-model="queryParam1.num4" @change="onChangeFreezeOrder">冻结订单</a-checkbox>
              <a-checkbox v-model="queryParam1.num5" @change="onChangeSuspendOrder">暂不结算订单</a-checkbox>
            </a-col>
            <a-col :span="9" :style="{ textAlign: 'right' }">
              <!--              查询功能待完善 只能查询公司名-->
              <a-button type="primary" htmlType="submit" @click="handSelect">查询</a-button>
              <a-button style="margin-left: 8px" @click="handleClear()">清空</a-button>
              <a-button v-if="exportEnable" type="primary" style="margin-left: 8px" @click="FileExcel"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="isShow == 0" style="cursor: pointer" @click="getMore"
                ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
              /></span>

              <span v-if="isShow == 1" style="cursor: pointer" @click="hiddenMore"
                ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
            </a-col>
          </a-row>

          <a-divider />
        </a-form>
      </div>
      <a-row>
        <a-col :span="4" :offset="20" :style="{ textAlign: 'right' }">
          <a-button
            v-if="assignPrincipalEnabel"
            type="primary"
            @click="Designate"
            :disabled="selectedRowKeys.length == 0"
            >指派</a-button
          >
        </a-col>
      </a-row>

      <s-table
        ref="table"
        :pagination="pagination"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 3100 }"
        style="margin-top: 20px"
        bordered
      >
        <span slot="orderNo" slot-scope="text, record">
          <a @click="showState2(record)" class="hover">{{ text }}</a>
          <a title="复制"><a-icon type="copy" class="copy" @click="Copys(record)" /></a>
        </span>
        <span slot="clientName" slot-scope="text, record">
          <span class="hover">{{ text }} </span>
          <a title="复制"><a-icon type="copy" class="copy" @click="Copys1(record)" /></a>
        </span>
        <span slot="action" slot-scope="text, record" style="white-space: nowrap">
          <a v-if="finishCancelEnable" @click="handleEdit(record.orderId)">核销</a>
          <a-divider type="vertical" />
          <a v-if="record.orderStatus == '待结单'" @click="handleCoverage(record)">结单</a>
          <a-divider v-if="record.orderStatus == '待结单'" type="vertical" />
          <a v-if="record.isSaleOrder == 0" @click="handleSaleOrder(record)">师傅销单</a>
          <a-divider type="vertical" v-if="record.isSaleOrder == 0" />
          <a @click="showState(record)">备注</a>
        </span>
      </s-table>
      <cancel-list-model ref="modal" @ok="hanleDesignateClear" />
      <examine-cancel-model ref="modal2" @ok="hanleDesignateClear" />
      <a-modal
        title="备注"
        style="top: 20px"
        :width="800"
        v-model="visible"
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        @cancel="handleClose"
        :closable="false"
        :maskClosable="false"
      >
        <a-form :form="form2" @submit="handleSubmit">
          <a-form-item label="">
            <a-textarea
              v-decorator="['remarkInfo', { rules: [{ required: true, message: '请输入备注内容' }] }]"
              :rows="4"
            />
          </a-form-item>
        </a-form>
      </a-modal>
      <edit-order-model v-if="$store.state.user_type == 1" ref="modal3" @ok="hanleDesignateClear"></edit-order-model>
      <edit-order-model1 v-else ref="modal3" @ok="hanleDesignateClear"></edit-order-model1>

      <change-remarks-model @ok="query()" ref="changeremarksmodel"></change-remarks-model>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>

<script>
import { getOrderDetail } from '@/api/order/orderList'
import store from '@/store'
import { STable } from '@/components'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import {
  updateSaleOrder,
  getQuestion,
  selectIsSecond,
  exportWriteoff,
  completeOrder,
  addOrderRemark,
  findByDeptId,
  getSlectCombox,
  getOrderTypeList,
  getelectAreaName,
  getelectCityName,
  getSelectAllProvince,
  queryOrderWriteOff,
} from '@/api/order/cancelList'
import examineCancelModel from './modules/examineCancelModel'
import NoAuthority from '../enterprise/NoAuthority'

import moment from 'moment'
import changeRemarksModel from './modules/changeRemarksModel'
const options = [
  { label: '建单时间', value: 'createTime' },
  { label: '销单时间', value: 'saleTime' },
  { label: '核销时间', value: 'checkTime' },
  { label: '订单完成时间', value: 'orderFinishTime' },
]

export default {
  name: 'CancelList',
  components: {
    STable,
    cancelListModel: () => import('./modules/cancelListModel'),
    examineCancelModel,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    NoAuthority,
    changeRemarksModel,
  },
  data() {
    return {
      reslist: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      userName: '',
      queryParam: {},
      queryParam1: {},
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        if (this.userName != '') {
          this.queryParam.writeoffUserCharge = this.userName
        }
        return queryOrderWriteOff(Object.assign(parameter, this.queryParam))
      },
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      columns: [
        {
          title: '序号',
          width: 60,
          dataIndex: 'sort',
          align: 'center',
        },
        {
          title: '操作栏',
          width: 60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },

        {
          title: '企业名称',
          dataIndex: 'enterpriseSysName',
          align: 'center',
        },
        {
          title: '核销状态',
          dataIndex: 'writeoffStatus',
          align: 'center',
        },
        {
          title: '核销方式',
          dataIndex: 'writeoffMode',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          scopedSlots: { customRender: 'clientName' },
          align: 'center',
        },
        {
          title: '客户联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'address',
          width: '300px',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },

        {
          title: '核销负责人',
          dataIndex: 'writeoffUserCharge',
          align: 'center',
        },
        {
          title: '核销人',
          dataIndex: 'writeoffUser',
          align: 'center',
        },
        {
          title: '状态栏',
          dataIndex: 'orderLevel',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubstatus',
          align: 'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'workName',
          align: 'center',
        },
        {
          title: '师傅联系方式',
          dataIndex: 'workPhone',
          align: 'center',
        },
        {
          title: '介入时间',
          dataIndex: 'intervenTimeDuration',
          align: 'center',
        },
        {
          title: '核销耗时',
          dataIndex: 'writeoffTimeDuration',
          align: 'center',
        },
        {
          title: '核销时间',
          dataIndex: 'checkTime',
          align: 'center',
        },
      ],
      options, // 检索下拉
      restaurantTypes1: [], // 安装类别
      restaurantTypes2: [
        { label: '待核销', value: 'reviewOrder' },
        { label: '待结单', value: 'completeOrder' },
        { label: '待结算', value: 'settleOrder' },
        { label: '退单', value: 'returnOrder' },
        { label: '关闭订单', value: 'closeOrder' },
        { label: '已结单', value: 'endOrder' },
      ], // 订单状态
      restaurantTypes3: [], // 订单子状态
      optionsradio: [
        { label: '小时', value: '0' },
        { label: '天', value: '1' },
      ],
      isShow: 0, // 更多、隐藏
      selectedRows: [], // 多选
      selectedRowKeys: [], // 多选
      data1: [], // 省下拉
      data2: [], // 市下拉
      data3: [], // 区下拉
      data4: [], // 订单类型下拉
      data5: [], // 企业下拉
      data6: [], // 订单负责人、协助人
      visible: false, // 备注
      orderId: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      finishCancelEnable: checkPermission('order:cancelList:finishCancel'),
      assignPrincipalEnabel: checkPermission('order:cancelList:assignPrincipal'),
      exportEnable: checkPermission('order:cancelList:export'),
      selectAll: checkPermission('order:cancelList:selectAll'),
      queryList: checkPermission('order:cancelList:view:query:list'),
    }
  },
  async created() {
    // console.log(store.getters)
    // console.log(this.userName,this.selectAll)
    if (!this.selectAll) {
      this.userName = store.getters.nickname
    }
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.handSelect()
    //   }
    // })
    // 安装类别
    this.restaurantTypes1 = []
    this.restaurantOperTypeMap1 = await getDictMap('install_type')
    this.restaurantOperTypeMap1.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes1.push({ code: key, label: value })
    })
    // 订单状态
    // this.restaurantTypes2 = [];
    // this.restaurantOperTypeMap2 = await getDictMap('order_status');
    // this.restaurantOperTypeMap2.forEach((value, key) => {
    //   console.log(value,key)
    //   this.restaurantTypes2.push({code: key, label: value})
    // })
    // 订单子状态
    this.restaurantTypes3 = []
    this.restaurantOperTypeMap3 = await getDictMap('order_substate')
    this.restaurantOperTypeMap3.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes3.push({ code: key, label: value })
    })
    // 省下拉
    getSelectAllProvince().then((res) => {
      // console.log(res)
      this.data1 = res.rows
    })
    // 企业下拉 isAuthority 1   数据隔离
    getSlectCombox({ isAuthority: 1 }).then((res) => {
      // console.log(res.data)
      this.data5 = res.data
    })
    // 订单负责人、协助人
    findByDeptId().then((res) => {
      // console.log(res)
      this.data6 = res
    })
  },
  // destroyed () {
  //   document.body.removeEventListener('keyup', e => {})
  // },
  methods: {
    // 初始
    showState2(record) {
      if (record) {
        this.$refs.changeremarksmodel.showChangeRemark(record.orderId)
      }
    },

    address(e) {
      console.log(e.target.value)
      // return value.trim()
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    moment,
    // 导出
    FileExcel() {
      var str = process.env.VUE_APP_API_BASE_URL + '/order/writeoff/exportWriteoff?pageNum=1&pageSize=10'
      for (const i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
      // exportWriteoff (this.queryParam).then(res=>{
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = '核销列表'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    handSelect() {
      this.queryParam.provinceId = this.form.getFieldValue('provinceId')
      this.queryParam.cityId = this.form.getFieldValue('cityId')
      this.queryParam.districtId = this.form.getFieldValue('districtId')
      this.queryParam.detailedAddress = this.form.getFieldValue('detailedAddress')
      if (this.selectAll) {
        this.$refs.table.refresh(true)
      } else {
        this.queryParam.writeoffUserCharge = this.userName
        this.$refs.table.refresh(true)
      }
    },
    handleClear() {
      this.data2 = []
      this.data3 = []
      this.data4 = []
      this.form.setFieldsValue({
        provinceId: undefined,
        cityId: undefined,
        districtId: undefined,
        detailedAddress: undefined,
      })
      this.queryParam = {}
      this.queryParam1 = {}
    },
    handleSaleOrder(record) {
      const that = this
      this.$confirm({
        title: '',
        content: '您是否确定销单？',
        okType: 'danger',
        onOk() {
          updateSaleOrder({ orderId: record.orderId }).then((res) => {
            if (res.code === 0) {
              that.$message.success('销单成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    // 单选
    onChangeRadioGroup(e) {
      console.log(e.target.value)
    },
    // 多选
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(selectedRowKeys, selectedRows)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 更多、隐藏
    getMore() {
      this.isShow = 1
    },
    hiddenMore() {
      this.isShow = 0
    },
    // 复制
    Copys(val) {
      // console.log(val,'点击复制')
      this.copyData = val.orderNo
      this.handcopy(this.copyData)
    },
    Copys1(val) {
      // console.log(val,'点击复制')
      this.copyData = `客户姓名:` + val.clientName + '\n' + `联系方式:` + val.clientPhone
      this.handcopy(this.copyData)
    },
    handcopy(data) {
      const url = data
      const oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      // console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    // 时间控件
    onChangerangepicker1(date, dateString) {
      this.queryParam.timeBegin1 = dateString[0]
      this.queryParam.timeEnd1 = dateString[1]
      // console.log(dateString)
    },
    onChangerangepicker2(date, dateString) {
      this.queryParam.timeBegin2 = dateString[0]
      this.queryParam.timeEnd2 = dateString[1]
      // console.log(dateString)
    },
    onChangerangepicker3(date, dateString) {
      this.queryParam.timeBegin3 = dateString[0]
      this.queryParam.timeEnd3 = dateString[1]
      // console.log(dateString)
    },
    // 市区
    haveProvince1(e) {
      this.data2 = []
      this.data3 = []
      this.queryParam.detailedAddress = undefined
      this.form.setFieldsValue({ cityId: undefined, districtId: undefined, detailedAddress: undefined })
      getelectCityName({ provinceCode: e }).then((res) => {
        // console.log(res)
        this.data2 = res.rows
      })

      // getelectCityName({provinceCode:this.queryParam.serviceProvinceId}).then(res=>{
      //   // console.log(res)
      //   this.data2=res.rows
      // })
    },
    haveProvince2(e) {
      this.data3 = []
      this.queryParam.detailedAddress = undefined
      this.form.setFieldsValue({ districtId: undefined, detailedAddress: undefined })
      getelectAreaName({ cityCode: e }).then((res) => {
        // console.log(res)
        this.data3 = res.rows
      })

      // getelectAreaName({cityCode:this.queryParam.serviceCityId}).then(res=>{
      //   // console.log(res)
      //   this.data3=res.rows
      // })
    },
    haveProvince3() {
      this.form.setFieldsValue({ detailedAddress: undefined })
    },
    // 订单类型下拉
    handleOrder(value) {
      this.queryParam.orderType = undefined
      this.form.setFieldsValue({ orderType: undefined })
      getOrderTypeList(value).then((res) => {
        // console.log(res)
        this.data4 = res.rows
      })
    },
    // 企业下拉
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange(value) {
      console.log(`selected ${value}`)
      // this.queryParam.enterpriseId= value
    },
    // 我的订单
    onChangeMyOrder(e) {
      if (e.target.checked) {
        this.queryParam.myOrder = 1
      } else {
        this.queryParam.myOrder = 0
      }
    },
    // 加急订单
    onChangeRushOrder(e) {
      if (e.target.checked) {
        this.queryParam.urgentOrder = 1
      } else {
        this.queryParam.urgentOrder = 0
      }
    },
    // 重要订单
    onChangeImportanceOrder(e) {
      if (e.target.checked) {
        this.queryParam.mainOrder = 1
      } else {
        this.queryParam.mainOrder = 0
      }
    },
    // 冻结订单
    onChangeFreezeOrder(e) {
      if (e.target.checked) {
        this.queryParam.freezeOrder = 1
      } else {
        this.queryParam.freezeOrder = 0
      }
    },
    // 暂不结算订单
    onChangeSuspendOrder(e) {
      if (e.target.checked) {
        this.queryParam.temporarilySettle = 1
      } else {
        this.queryParam.temporarilySettle = 0
      }
    },
    // 指派
    Designate() {
      const record = this.selectedRows
      const data = this.data6
      this.$refs.modal.designate(record, data)
    },
    hanleDesignateClear() {
      this.queryParam.provinceId = this.form.getFieldValue('provinceId')
      this.queryParam.cityId = this.form.getFieldValue('cityId')
      this.queryParam.districtId = this.form.getFieldValue('districtId')
      this.queryParam.detailedAddress = this.form.getFieldValue('detailedAddress')
      if (this.selectAll) {
        this.$refs.table.refresh()
      } else {
        this.queryParam.writeoffUserCharge = this.userName
        this.$refs.table.refresh()
      }
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // 核销
    handleEdit(id) {
      this.$refs.modal3.showeditOrder(id, 1, 1, '', '', '', '', true)
      // console.log(record)
      // getQuestion(record.orderId).then(res=>{
      //   if(res.data == null){
      //     this.$refs.modal.edit(record,1)
      //   }else{
      //     this.$refs.modal2.show(record)
      //   }
      // })
    },
    handleOk() {
      this.$refs.table.refresh()
    },

    // 结单
    handleCoverage(record) {
      const that = this
      if (record.payType == 1) {
        this.$refs.modal3.showeditOrder(record.orderId, 1, 1, '', '', '', '', true)
      } else if (record.factoryStatus == 1) {
        this.$refs.modal3.showeditOrder(record.orderId, 1, 1, '', '', '', '', true)
      } else {
        this.$confirm({
          title: '',
          content: '您是否确定结单？',
          okType: 'danger',
          onOk() {
            completeOrder({ orderId: record.orderId, procInstId: record.procInstId, applyResult: 0 }).then((res) => {
              if (res.code === 0) {
                that.$message.success('结单成功')
                that.handleOk()
              } else {
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel')
          },
        })
      }
    },
    // 备注
    showState(record) {
      console.log('record', record)
      this.form2.setFieldsValue({
        remarkInfo: '',
      })
      this.visible = true
      this.orderId = record.orderId
    },
    // 提交备注
    handleSubmit(e) {
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          values.orderId = this.orderId
          values.remarkType = 0
          // console.log('Received values of form: ', values)
          this.confirmLoading = true
          addOrderRemark(values)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success('提交成功')
                this.handleOk()
                this.visible = false
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
  },
  watch: {},
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
